import apiHandling from "./apiHandling";

export default class apiApp extends apiHandling {
    constructor() {
        super();
    }

    static getEmployeesTakeExam = (data) => this.req({
            'method': 'get',
            'action': 'lamp',
            'data': data,
        });

    static getSettings = (window = 'first-window') => this.req({
            'method': 'get',
            'action': `lamp/settings/${window}`
        });
}